import {
  _sharedActionsConstantsSearch,
  _sharedActionsSearch
} from "@/shared/store/search/actions";

const prefix = "search/";

export const searchActionConstants = {
  SEARCH_SUCCESS: "SEARCH_SUCCESS",
  ACTION_SEARCH: "ACTION_SEARCH",
  SEARCH_CLEAR: "SEARCH_CLEAR",
  RESET: prefix + "RESET",
  ACTION_SEARCH_PARAMS_UPDATE: "ACTION_SEARCH_PARAMS_UPDATE",
  ACTION_SEARCH_CURRENT_ITEM_UPDATE: "ACTION_SEARCH_CURRENT_ITEM_UPDATE",
  SEARCH_TOGGLE_MARKS: "SEARCH_TOGGLE_MARKS",

  FETCH_SEARCH_DICTIONARY: "FETCH_SEARCH_DICTIONARY",
  FETCH_SEARCH_DICTIONARY_SUCCESS: "FETCH_SEARCH_DICTIONARY_SUCCESS",

  ..._sharedActionsConstantsSearch,
};

export const searchActions = {
  search: (data, onSuccess) => ({
    type: searchActionConstants.ACTION_SEARCH,
    data: { actionSearchParams: data, onSuccess },
  }),
  searchCurrentItemUpdate: (data) => ({
    type: searchActionConstants.ACTION_SEARCH_CURRENT_ITEM_UPDATE,
    data,
  }),
  searchSuccess: (data) => ({
    type: searchActionConstants.SEARCH_SUCCESS,
    data,
  }),
  searchClear: () => ({
    type: searchActionConstants.SEARCH_CLEAR,
  }),
  reset: () => ({
    type: searchActionConstants.RESET,
  }),
  searchToggleMarks: () => ({
    type: searchActionConstants.SEARCH_TOGGLE_MARKS,
  }),
  searchDictionary: (query, dictionary) => ({
    type: searchActionConstants.FETCH_SEARCH_DICTIONARY,
    data: { query, dictionary },
  }),
  searchDictionarySuccess: (params, results) => ({
    type: searchActionConstants.FETCH_SEARCH_DICTIONARY_SUCCESS,
    data: { params, results },
  }),

  ..._sharedActionsSearch,
};
